import { render, staticRenderFns } from "./PuzzleCell.vue?vue&type=template&id=1a5bbba0&scoped=true&"
import script from "./PuzzleCell.vue?vue&type=script&lang=js&"
export * from "./PuzzleCell.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleCell.vue?vue&type=style&index=0&id=1a5bbba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5bbba0",
  null
  
)

export default component.exports